<button
  type="button"
  matFab
  color="primary"
  class="!h-12 !w-12 text-[20px] leading-[20px] blue-theme-bg-1 !fixed !z-[1000] round-btn"
  [ngClass]="{
    '!bottom-1/2 !translate-y-12 !right-4': positionButton === 'right',
    '!top-4 !left-1/2 !-translate-x-5': positionButton === 'up',
    '!top-1/2 !left-16': positionButton === 'left',
    '!bottom-4 !right-1/2 !translate-x-7': positionButton === 'down',
  }"
  name="MainSideBtn"
  [class.active]="isOpen"
  (click)="toggleActive($event)"
  [attr.aria-label]="ariaLabel"
>
  <mat-icon>{{ mainButtonImage }}</mat-icon>
</button>

<phoenix-secondary-side-buttons
  [hidden]="!isOpen"
  [buttons]="buttons"
  (buttonClicked)="buttonClicked.emit($event)"
  class="fixed z-[100] flex"
  [ngClass]="classForPosition"
  [ngStyle]="{
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    transition: 'opacity 0.5s ease-in-out',
  }"
></phoenix-secondary-side-buttons>
